export { default as Tab } from './Tab';
export { default as TabComponent } from './TabComponent';
export { default as Tabs } from './Tabs';
export { default as TabList } from './TabList';
export { default as TabListComponent } from './TabListComponent';
export { default as TabPanel } from './TabPanel';
export { default as TabPanelComponent } from './TabPanelComponent';
export { default as TabProvider } from './TabProvider';
export { default as TabSelection } from './TabSelection';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-web-tabs/es/index.js
// module id = 232
// module chunks = 0